<template>
    <div class="compare">
        <filter-component :ads="ads" :campaigns="campaigns" :agreements="agreements" :brands="brands" :publishers="publishers" @filtered-items="handleFilteredItems"/>
        <overview-component :filteredItems="filteredItems" />
    </div>
  </template>

  <script>
  import FilterComponent from './Filter.vue';
  import OverviewComponent from './Overview.vue';

  export default {
    components: {
      FilterComponent,
      OverviewComponent,
    },
    props: {
        campaigns: { type: Array, required: true },
        agreements: { type: Array, required: true },
        brands:  { type: Array, required: true },
        publishers:  { type: Array, required: true },
        ads: { type: Array, required: true },
    },
    data() {
        return {
            filteredItems: [],
        };
    },
    methods: {
        handleFilteredItems(value) {
           this.filteredItems = value;
        }
    }
  };
  </script>
